// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8i2vN","col":"styles_col__3cBB5"};